var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-topic-search"},[_c('TopicSearchPanel',{ref:"search",attrs:{"show":true},on:{"cancel":_vm.goBack,"select":_vm.viewTopicDetail}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }